import { connect } from "react-redux";

import SignIn from "../components/SignIn";
import { Dispatch, StoreState } from "../store";

function mapStateToProps({ auth: { error, password, username } }: StoreState) {
  return {
    error,
    password,
    username,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onPasswordChange: (password: string) =>
      dispatch.auth.changePassword(password),
    onSubmit: (username: string, password: string) =>
      dispatch.auth.login({ username, password }),
    onUsernameChange: (username: string) =>
      dispatch.auth.changeUsername(username),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);



// WEBPACK FOOTER //
// ./src/containers/SignIn.tsx